// extracted by mini-css-extract-plugin
export default {"MapComponent":"MapComponent_MapComponent__fRpN6"};